/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneLayout as ResolvedStandaloneLayout } from 'base/components/standalone/Layout';

export const Layout: typeof ResolvedStandaloneLayout = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneLayout {...props} />
    );
});

export type LayoutProps = PropsFromComponent<typeof Layout>;

/** @deprecated Use slot architecture instead */
export const LayoutWith = (extras: DynamicStandaloneExtras): typeof Layout => {
    return function Layout(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Layout');
        return <ResolvedStandaloneLayout {...mergeProps({ options: { theme } }, props)} />;
    }
}